import { styledThemed as styled } from "../theme";

export const SectionDivider = styled.div`
  width: 100%;
  left: 0;
  border-top: 1px dashed ${(p) => p.theme.av8.primaryColor}18;
`;
